import HomeText from './HomeText';
// import HomeLogo from './HomeLogo';

const Home = () => {

    return ( <div id="Home" className="page">

        <div className='home-content'>
            <HomeText/>
            {/* <HomeLogo/> */}
        </div>
        
    </div> );
}
 
export default Home;